import { chain } from 'ramda';
import { deleteNodesCollection } from './qRules.node.helpers';
import { setNodeValue } from '../../../xmlUtility';

export const sharePointListItemAttributeXPathQRulesLastModified =
    "@*[starts-with(local-name(), 'qRulesLastModified')]";

const getShpItemsGroup = async (mapping) => {
    const mappingNode = mapping.baseNode;
    const shpItemsGroup = mappingNode.selectSingle('SharePointItems');

    if (shpItemsGroup) {
        return shpItemsGroup;
    }

    //if it does not exist, create it
    const sharePointItemNode = mappingNode.createElement('SharePointItems');

    await mappingNode.appendChildAsync(sharePointItemNode);

    return mappingNode.selectSingle('SharePointItems');
};

function appendSharePointItem(shpItemsGroup, id, lastModified) {
    var sharePointItem = shpItemsGroup.createElement('SharePointItem'),
        idItem = shpItemsGroup.createElement('Id'),
        lastModifiedItem = shpItemsGroup.createElement('LastModified');

    setNodeValue(idItem, id);
    setNodeValue(lastModifiedItem, lastModified);

    sharePointItem.appendChild(idItem);
    sharePointItem.appendChild(lastModifiedItem);

    return shpItemsGroup.appendChildAsync(sharePointItem);
}

function updateOrAddShpItem(shpItemsGroup, item) {
    var id = item.value(),
        lastModified = item
            .selectSingle(sharePointListItemAttributeXPathQRulesLastModified)
            .value();
    //see if item is already in list
    var shpItem = shpItemsGroup.selectSingle('SharePointItem[Id="' + id + '"]');

    //if not
    if (!shpItem) {
        //create item, populate, append
        // Case 36150 - We only need to append the created element to the SharePointItems group once
        return appendSharePointItem(shpItemsGroup, id, lastModified);
    }

    //else, update the last modified
    return shpItem.selectSingle('LastModified').setValueAsync(lastModified);
}

export async function updateFormItemList(nodes, pathToIds, mapping) {
    //try to get SharePointItem repeating group
    const shpItemsGroup = await getShpItemsGroup(mapping);
    //try to get SharePointItem repeating group
    const shpItems = shpItemsGroup.selectNodes('SharePointItem');

    const xPath = `${pathToIds}[. != "" and ${sharePointListItemAttributeXPathQRulesLastModified}]`;

    // Items in main DOM
    const items = chain((node) => node.selectNodes(xPath), nodes);

    //if count is different between SharePointItem and form items, delete the SharePointItem groups
    if (shpItems.length !== items.length) {
        deleteNodesCollection(shpItems);
    }

    for (const item of items) {
        await updateOrAddShpItem(shpItemsGroup, item);
    }
}
